module.exports = __webpack_public_path__ + "img/chart1.11179391.jpg";